import Cookies from "js-cookie";
import { IUserData } from "./types";
export function GetProfileImg(pic: string) {
    if (!pic) {
        return "https://cdn.doras.to/doras/defaultimage.jpeg";
    }
    return "https://cdn.doras.to/doras/user/" + pic;
}
export const setCookie = (
    name: string,
    value: string,
    expiresInSeconds: number
) => {
    const expirationDate = new Date(Date.now() + expiresInSeconds * 1000);
    Cookies.set(name, value, {
        expires: expirationDate,
        secure: true,
        sameSite: "lax",
    });
};
export function Navigation(
    router: { push: (arg0: any) => any; refresh: () => any },
    href: string
) {
    router.push(href);
    // router.refresh();
}

export function CheckStaff(user: IUserData | null) {
    if (user?.access == "admin" || user?.access == "staff") {
        return true;
    }
    return false;
}

export function UserURL(user: IUserData | null | undefined) {
    if (!user) return "doras.to";
    if (
        (user?.account_type == "premium" &&
            user?.domain.domain !== "" &&
            user.domain.verified) ||
        (user?.account_type == "bplus" &&
            user?.domain.domain !== "" &&
            user.domain.verified) ||
        (user?.account_type == "bpro" &&
            user?.domain.domain !== "" &&
            user.domain.verified)
    ) {
        return `${user.domain.domain}`;
    }
    return `doras.to/${user?.username}`;
}
export function UserShortURL(user: IUserData | null | undefined) {
    if (!user) return "doras.to";
    if (
        (user?.account_type == "premium" &&
            user?.domain.domain !== "" &&
            user.domain.verified) ||
        (user?.account_type == "bplus" &&
            user?.domain.domain !== "" &&
            user.domain.verified) ||
        (user?.account_type == "bpro" &&
            user?.domain.domain !== "" &&
            user.domain.verified)
    ) {
        return `${user.domain.domain}/s`;
    }
    return `${user?.username}.doras.click`;
}

export function isHttpOrHttpsUrl(url: string): boolean {
    const regex = /^(http:\/\/|https:\/\/)/;
    return regex.test(url);
}

export async function fetchPing(url: string): Promise<number> {
    const startTime = performance.now();
    try {
        const response = await fetch(url, {
            method: "GET",
            headers: {
                "Content-Type": "application/json",
            },
        });
        if (!response.ok) {
            console.error(`Failed to fetch ${url}, status ${response.status}`);
            return -1; // Return a negative value to indicate failure
        }
        const endTime = performance.now();
        const pingTime = endTime - startTime;
        // console.log(
        //     `Ping time for ${url}: ${pingTime.toFixed(2)} milliseconds`
        // );
        return pingTime;
    } catch (error) {
        console.error("Error during ping:", error);
        return -1; // Return a negative value to indicate failure
    }
}

export function matchDorasPattern(str: string) {
    const regex = /^doras_.*/;
    return regex.test(str);
}
